module.exports = __webpack_public_path__ + "img/bg.2059e3e2.svg";